export default __webpack_public_path__ + "static/HeldaneDisplayWeb-Medium-76741a4ee2037dd6e10b5ddcd0576a2f.woff2";